// specializationIcons.ts
// Автоматически сгенерированные импорты и конфигурация
import { ReactComponent as ThreeDpProductionSpecialist } from './assets/3dp-production-specialist.svg'
import { ReactComponent as AmplifyAudioSpecialist } from './assets/amplify-audio-specialist.svg'
import { ReactComponent as AmplifyEducationSolutionsSpecialist } from './assets/amplify-education-solutions-specialist.svg'
import { ReactComponent as AmplifyMpsSpecialist } from './assets/amplify-mps-specialist.svg'
import { ReactComponent as AmplifyPrintLifecycleServices } from './assets/amplify-print-lifecycle-services.svg'
import { ReactComponent as AmplifyPsLifecycleServices } from './assets/amplify-ps-lifecycle-services.svg'
import { ReactComponent as AmplifyRetailHospitalitySolutionsSpecialist } from './assets/amplify-retail-hospitality-solutions-specialist.svg'
import { ReactComponent as AmplifySitePrintSolutionsSpecialist } from './assets/amplify-site-print-solutions-specialist.svg'
import { ReactComponent as AmplifyVideoSpecialist } from './assets/amplify-video-specialist.svg'
import { ReactComponent as AmplifyVoiceSpecialist } from './assets/amplify-voice-specialist.svg'
import { ReactComponent as AmplifyWorkstationsBusinessSpecialist } from './assets/amplify-workstations-business-specialist.svg'
import { ReactComponent as DiversityNetwork } from './assets/diversity-network.svg'
import { ReactComponent as HpAnywareSell } from './assets/hp-anyware-sell.svg'
import { ReactComponent as HpAnywareService } from './assets/hp-anyware-service.svg'
import { ReactComponent as HpEndPointSecuritySell } from './assets/hp-end-point-security-sell.svg'
import { ReactComponent as HpEndPointSecurityService } from './assets/hp-end-point-security-service.svg'
import { ReactComponent as HpInsightsAnalyticsSell } from './assets/hp-insights-analytics-sell.svg'
import { ReactComponent as HpInsightsAnalyticsService } from './assets/hp-insights-analytics-service.svg'
import { ReactComponent as HpSoftwareSpecialist } from './assets/hp-software-specialist.svg'
import { ReactComponent as HybridSpecialist } from './assets/hybrid-specialist.svg'
import { ReactComponent as InternationalTradeSpecialist } from './assets/international-trade-specialist.svg'
import { ReactComponent as LfDesignSolutionsContractualDesignjetTrack } from './assets/lf-design-solutions-contractual-designjet-track.svg'
import { ReactComponent as LfDesignSolutionsContractualLtpTrack } from './assets/lf-design-solutions-contractual-ltp-track.svg'
import { ReactComponent as LfDesignSolutionsContractualTpTrack } from './assets/lf-design-solutions-contractual-tp-track.svg'
import { ReactComponent as LfDesignSolutionsDesignjetValueTrack } from './assets/lf-design-solutions-designjet-value-track.svg'
import { ReactComponent as LfDesignSolutionsGraphicsProductionTrack } from './assets/lf-design-solutions-graphics-production-track.svg'
import { ReactComponent as LfDesignSolutionsHybridSolutionsTrack } from './assets/lf-design-solutions-hybrid-solutions-track.svg'
import { ReactComponent as LfDesignSolutionsLiteProductionItVarTrack } from './assets/lf-design-solutions-lite-production-it-var-track.svg'
import { ReactComponent as LfDesignSolutionsLiteProductionTrack } from './assets/lf-design-solutions-lite-production-track.svg'
import { ReactComponent as LfDesignSolutionsOnlineTrack } from './assets/lf-design-solutions-online-track.svg'
import { ReactComponent as LfDesignSolutionsProductionTrack } from './assets/lf-design-solutions-production-track.svg'
import { ReactComponent as LfDesignSolutionsSpTrack } from './assets/lf-design-solutions-sp-track.svg'
import { ReactComponent as LfDesignSolutionsTechnicalProdItVarTrack } from './assets/lf-design-solutions-technical-prod-it-var-track.svg'
import { ReactComponent as LfDesignSolutionsTechnicalProductionTrack } from './assets/lf-design-solutions-technical-production-track.svg'
import { ReactComponent as LfPTSolutionsCommTextiledyeSubTrack } from './assets/lf-p-t-solutions-comm-textiledye-sub-track.svg'
import { ReactComponent as LfPTSolutionsCommercialEntryTrack } from './assets/lf-p-t-solutions-commercial-entry-track.svg'
import { ReactComponent as LfPTSolutionsCommercialProductivityTrack } from './assets/lf-p-t-solutions-commercial-productivity-track.svg'
import { ReactComponent as LfPTSolutionsContractualSdTrack } from './assets/lf-p-t-solutions-contractual-sd-track.svg'
import { ReactComponent as LfPTSolutionsPagewideXlGraphicsTrack } from './assets/lf-p-t-solutions-pagewide-xl-graphics-track.svg'
import { ReactComponent as LfPTSolutionsProdTextiledyeSubTrack } from './assets/lf-p-t-solutions-prod-textiledye-sub-track.svg'
import { ReactComponent as LfPTSolutionsProductionMidVolumeEntryTrack } from './assets/lf-p-t-solutions-production-mid-volume-entry-track.svg'
import { ReactComponent as LfPTSolutionsProductionMidVolumeTrack } from './assets/lf-p-t-solutions-production-mid-volume-track.svg'
import { ReactComponent as LfPTSolutionsRSeriesSolutionsTrack } from './assets/lf-p-t-solutions-r-series-solutions-track.svg'
import { ReactComponent as LfPTSolutionsSdSolutionsTrack } from './assets/lf-p-t-solutions-sd-solutions-track.svg'
import { ReactComponent as LfPTSolutionsUvInkSolutionsTrack } from './assets/lf-p-t-solutions-uv-ink-solutions-track.svg'
import { ReactComponent as LfSelectContractualTechnicalProductionTrack } from './assets/lf-select-contractual-technical-production-track.svg'
import { ReactComponent as MpsSubscriptionSpecialist } from './assets/mps-subscription-specialist.svg'
import { ReactComponent as PaymentSolutionsSpecialization } from './assets/payment-solutions-specialization.svg'
import { ReactComponent as PrintSolutionsSell } from './assets/print-solutions-sell.svg'
import { ReactComponent as PrintSolutionsService } from './assets/print-solutions-service.svg'
import { ReactComponent as PublicSectorNetwork } from './assets/public-sector-network.svg'
import { ReactComponent as WorkforceExperienceSell } from './assets/workforce-experience-sell.svg'
import { ReactComponent as WorkforceExperienceService } from './assets/workforce-experience-service.svg'
import { PartnerSpecializationIcon } from './models'

export const SpecializationConfig: PartnerSpecializationIcon[] = [
  { label: 'Amplify Voice Specialist', icon: <AmplifyVoiceSpecialist /> },
  {
    label: 'LF Design Solutions - Hybrid Solutions Track',
    icon: <LfDesignSolutionsHybridSolutionsTrack />,
  },
  {
    label: 'Amplify Education Solutions Specialist',
    icon: <AmplifyEducationSolutionsSpecialist />,
  },
  {
    label: 'LF P & T Solutions - Production Mid Volume Entry track',
    icon: <LfPTSolutionsProductionMidVolumeEntryTrack />,
  },
  {
    label: 'LF Design Solutions - Lite Production Track',
    icon: <LfDesignSolutionsLiteProductionTrack />,
  },
  { label: 'HP Anyware Service', icon: <HpAnywareService /> },
  {
    label: 'LF Design Solutions - Technical Production Track',
    icon: <LfDesignSolutionsTechnicalProductionTrack />,
  },
  {
    label: 'Amplify Retail & Hospitality Solutions Specialist',
    icon: <AmplifyRetailHospitalitySolutionsSpecialist />,
  },
  { label: 'HP Anyware Sell', icon: <HpAnywareSell /> },
  { label: 'HP Insights & Analytics Service', icon: <HpInsightsAnalyticsService /> },
  { label: 'MPS Subscription Specialist', icon: <MpsSubscriptionSpecialist /> },
  { label: 'Amplify Audio Specialist', icon: <AmplifyAudioSpecialist /> },
  {
    label: 'LF P & T Solutions - UV Ink Solutions Track',
    icon: <LfPTSolutionsUvInkSolutionsTrack />,
  },
  { label: 'Print Solutions Sell', icon: <PrintSolutionsSell /> },
  { label: 'Payment Solutions Specialization', icon: <PaymentSolutionsSpecialization /> },
  {
    label: 'LF Design Solutions - DesignJet Value Track',
    icon: <LfDesignSolutionsDesignjetValueTrack />,
  },
  {
    label: 'LF Select - Contractual Technical Production Track',
    icon: <LfSelectContractualTechnicalProductionTrack />,
  },
  {
    label: 'LF Design Solutions - Graphics Production Track',
    icon: <LfDesignSolutionsGraphicsProductionTrack />,
  },
  { label: 'Amplify PS Lifecycle Services', icon: <AmplifyPsLifecycleServices /> },
  { label: 'Public Sector Network', icon: <PublicSectorNetwork /> },
  {
    label: 'LF P & T Solutions - R Series Solutions Track',
    icon: <LfPTSolutionsRSeriesSolutionsTrack />,
  },
  { label: 'Workforce Experience Sell', icon: <WorkforceExperienceSell /> },
  {
    label: 'LF P & T Solutions - Commercial Entry Track',
    icon: <LfPTSolutionsCommercialEntryTrack />,
  },
  {
    label: 'Amplify Site Print Solutions Specialist',
    icon: <AmplifySitePrintSolutionsSpecialist />,
  },
  {
    label: 'LF P & T Solutions - Commercial Productivity Track',
    icon: <LfPTSolutionsCommercialProductivityTrack />,
  },
  { label: 'Amplify Print Lifecycle Services', icon: <AmplifyPrintLifecycleServices /> },
  { label: '3DP Production Specialist', icon: <ThreeDpProductionSpecialist /> },
  {
    label: 'LF P & T Solutions - Comm. Textile/Dye Sub Track',
    icon: <LfPTSolutionsCommTextiledyeSubTrack />,
  },
  { label: 'Hybrid Specialist', icon: <HybridSpecialist /> },
  { label: 'Workforce Experience Service', icon: <WorkforceExperienceService /> },
  { label: 'Amplify Video Specialist', icon: <AmplifyVideoSpecialist /> },
  {
    label: 'LF Design Solutions - Lite Production IT VAR Track',
    icon: <LfDesignSolutionsLiteProductionItVarTrack />,
  },
  {
    label: 'LF Design Solutions - Contractual TP Track',
    icon: <LfDesignSolutionsContractualTpTrack />,
  },
  { label: 'HP End Point Security Service', icon: <HpEndPointSecurityService /> },
  { label: 'Diversity Network', icon: <DiversityNetwork /> },
  { label: 'LF P & T Solutions - S&D Solutions Track', icon: <LfPTSolutionsSdSolutionsTrack /> },
  {
    label: 'LF P & T Solutions - Contractual S&D Track',
    icon: <LfPTSolutionsContractualSdTrack />,
  },
  { label: 'Print Solutions Service', icon: <PrintSolutionsService /> },
  {
    label: 'Amplify Workstations Business Specialist',
    icon: <AmplifyWorkstationsBusinessSpecialist />,
  },
  {
    label: 'LF P & T Solutions - Production Mid Volume Track',
    icon: <LfPTSolutionsProductionMidVolumeTrack />,
  },
  { label: 'HP End Point Security Sell', icon: <HpEndPointSecuritySell /> },
  { label: 'International Trade Specialist', icon: <InternationalTradeSpecialist /> },
  { label: 'LF Design Solutions Production Track', icon: <LfDesignSolutionsProductionTrack /> },
  {
    label: 'LF Design Solutions - Contractual LTP Track',
    icon: <LfDesignSolutionsContractualLtpTrack />,
  },
  { label: 'HP Insights & Analytics Sell', icon: <HpInsightsAnalyticsSell /> },
  {
    label: 'LF P & T Solutions - PageWide XL Graphics Track',
    icon: <LfPTSolutionsPagewideXlGraphicsTrack />,
  },
  {
    label: 'LF P & T Solutions - Prod Textile/Dye Sub Track',
    icon: <LfPTSolutionsProdTextiledyeSubTrack />,
  },
  { label: 'Amplify MPS Specialist', icon: <AmplifyMpsSpecialist /> },
  { label: 'LF Design Solutions - Online Track', icon: <LfDesignSolutionsOnlineTrack /> },
  {
    label: 'LF Design Solutions - Technical Prod IT VAR Track',
    icon: <LfDesignSolutionsTechnicalProdItVarTrack />,
  },
  { label: 'HP Software Specialist', icon: <HpSoftwareSpecialist /> },
  {
    label: 'LF Design Solutions - Contractual Designjet Track',
    icon: <LfDesignSolutionsContractualDesignjetTrack />,
  },
  { label: 'LF Design Solutions - SP Track', icon: <LfDesignSolutionsSpTrack /> },
]
